import React, { createContext, useContext } from 'react';
var PagePropsContext = createContext({});
export var PagePropsProvider = function (_a) {
    var children = _a.children, pageProps = _a.pageProps;
    return (React.createElement(PagePropsContext.Provider, { value: pageProps }, children));
};
export function usePageProps() {
    var context = useContext(PagePropsContext);
    if (context === undefined) {
        throw new Error("usePageProps must be used within a PagePropsProvider Provider");
    }
    return context;
}
